<template>
  <div>
    <div style="height: 44px"></div>
    <dashboardItem v-if="activeRate==='seller'" :infoData="summary.receivableSummary" :title="$t('common.receivables')"></dashboardItem>
    <dashboardItem v-if="activeRate==='buyer'" :infoData="summary.investmentSummary" :title="$t('common.investments')"></dashboardItem>
	<dashboardItem :infoData="overdueLevels" :title="$t('dashboardLeft.overduePayment')"></dashboardItem>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import dashboardItem from "./dashboardItem";
import {navigationUtils} from "@/common/navigation/navigationUtils";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
  props: {
    activeRate: [Number, String]
  },
  components: {
    dashboardItem
  },
  data() {
    return {
      summary: {
        investmentSummary: [
		  {
		  	key: "opportunities",
		  	$key: this.$t("dashboardLeft.Investments.Opportunities", { url: navigationUtils.getPathWithActiveTab(navigationPaths.investor.riskAssessment, navigationTabs.investor.riskAssessment.marketSoundingDecisions) }),
		  	count: "",
		  	amountKey: "totalReceivableAmount",
		  	amount: "",
		  },
          {
            key: "available",
			$key: this.$t("dashboardLeft.Investments.Available", { url: navigationUtils.getPathWithActiveTab(navigationPaths.investor.exchange, navigationTabs.investor.exchange.receivables) }),
            count: "",
            amountKey: "totalReceivableAmount",
            amount: "",
          },
          {
            key: "purchasedToday",
            $key: "dashboardLeft.Investments.PurchasedToday",
            count: "",
            amountKey: "totalInvestmentVolume",
            amount: "",
          }
        ],
        receivableSummary: [
          {
            key: "notCompleted",
            $key: "dashboardLeft.notCompleted",
            count: "",
            amountKey: "totalReceivableAmount",
            amount: "",
          },
          {
            key: "inVerification",
            $key: "dashboardLeft.Inveriﬁcation",
            count: "",
            amountKey: "totalReceivableAmount",
            amount: "",
          },
          {
            key: "readyForSale",
            $key: "dashboardLeft.Ready.sale",
            count: "",
            amountKey: "totalReceivableAmount",
            amount: "",
          },
          {
            key: "inSale",
            $key: "dashboardLeft.Insale",
            count: "",
            amountKey: "totalReceivableAmount",
            amount: "",
          }
        ],
        paymentsSummary: [
          {
            key: "overdueLevel1",
            $key: "dashboardLeft.Overdue.level1",
            count: "",
            amountKey: "outstandingAmount",
            amount: "",
          },
          {
            key: "overdueLevel2",
            $key: "dashboardLeft.Overdue.level2",
            count: "",
            amountKey: "outstandingAmount",
            amount: "",
          },
          {
            key: "overdueLevel3",
            $key: "dashboardLeft.Overdue.level3",
            count: "",
            amountKey: "outstandingAmount",
            amount: "",
          },
          {
            key: "overdueLevel4",
            $key: "dashboardLeft.Overdue.level4",
            count: "",
            amountKey: "outstandingAmount",
            amount: "",
          }
        ]
      }
    };
  },
  computed: {
    ...mapGetters({ dashboardInfo: "dashboardInfo" }),
  	overdueLevels(){
		let paymentsSummary = this.summary.paymentsSummary;
		//Hide last rows which dont contain data
		for (let i = paymentsSummary.length -1; i >= 0; i--) {
		  if (paymentsSummary[i].amount > 0 || paymentsSummary[i].key === 'overdueLevel1') {
			  return paymentsSummary.slice(0, i + 1)
		  }
	  }
	}
  },
  watch: {
    dashboardInfo() {
      Object.keys(this.summary).forEach(key => {
        if (!this.dashboardInfo.liveData.hasOwnProperty(key)) {
          return;
        }

        let data = this.dashboardInfo.liveData[key];
        this.summary[key].forEach(item => {
            item.count = data[item.key].count;
            item.amount = data[item.key][item.amountKey];
        });
      }, this);
    }
  }
};
</script>